












import { Component, Vue } from 'vue-property-decorator';
import SelectedElement from './SelectedElement.vue';
import Elements from './Elements.vue';
import BonusElements from './BonusElements.vue';
import Header from './Header.vue';
import Footer from './Footer.vue';
import { mapMutations } from 'vuex';

@Component({
  components: {
    Header,
    Footer,
    Elements,
    BonusElements,
    SelectedElement,
  },
  methods: mapMutations(['markFirstPage']),
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      vm.markFirstPage();
    });
  },
})
export default class Main extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Main.vue